import { useState } from 'react';

export const useImageCropper = () => {
  const [imagePreview, setImagePreview] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedImagePreview, setCroppedImagePreview] = useState(null);
  const [isCropping, setIsCropping] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setIsCropping(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const dataURLToBlob = async (dataUrl) => {
    const res = await fetch(dataUrl);
    return await res.blob();
  };

  const blobToDataURL = (blob) =>
    new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(blob);
    });

  const normalizeToBlob = async (output) => {
    if (!output) return null;
    if (output instanceof Blob || output instanceof File) return output;
    if (typeof output === 'string' && output.startsWith('data:image')) {
      return await dataURLToBlob(output);
    }
    if (output?.blob instanceof Blob) return output.blob;
    if (output?.file instanceof File) return output.file;
    if (typeof output?.toBlob === 'function') {
      return await new Promise((res) => output.toBlob(res, 'image/jpeg', 0.92));
    }
    return null;
  };

  const handleCropSave = async (output) => {
    const blob = await normalizeToBlob(output);
    if (!blob) {
      console.warn('handleCropSave: unsupported crop output', output);
      return null;
    }
    setCroppedImage(blob); // keep Blob in state for uploads
    const preview = await blobToDataURL(blob);
    setCroppedImagePreview(preview); // dataURL for UI
    setIsCropping(false);
    return blob; // state updates are async — callers submitting now need it
  };

  const resetImage = () => {
    setImagePreview(null);
    setCroppedImage(null);
    setCroppedImagePreview(null);
    setIsCropping(false);
  };

  return {
    imagePreview,
    croppedImage,
    croppedImagePreview,
    isCropping,
    handleImageChange,
    handleCropSave,
    setIsCropping,
    resetImage,
  };
};
